import React from "react";
import { Box, FormControl, InputLabel, Select, MenuItem } from "@mui/material";
import { SearchContainer, SearchInput } from "./styles/SearchBarStyles";

const SearchBar = ({ filtro, handleSearchChange, categoria, handleCategoriaChange, ciudadesUnicas }) => (
  <SearchContainer>
    <Box
      display="flex"
      justifyContent="center"
      alignItems="center"
      flexWrap="wrap"
      gap={2}
      mb={4}
    >
      <SearchInput
        value={filtro}
        onChange={handleSearchChange}
        placeholder="Buscar por nombre"
        endAdornment={null}
      />

      <FormControl sx={{ minWidth: 200 }}>
        <InputLabel id="select-categoria-label">Ciudad</InputLabel>
        <Select
          labelId="select-categoria-label"
          id="select-categoria"
          value={categoria}
          label="Ciudad"
          onChange={handleCategoriaChange}
        >
          <MenuItem value="">
            <em>Todos</em>
          </MenuItem>
          {ciudadesUnicas.map((ciudad, index) => (
            <MenuItem key={index} value={ciudad}>
              {ciudad}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </Box>
  </SearchContainer>
);

export default SearchBar;
